require('./dist/angular-gettext.js');
module.exports = 'gettext';
